import { useEffect, useState } from 'react';
import { CompanyProfile } from '../../company';
import { useParams } from 'react-router-dom';
import { getCompanyProfile } from '../../api';
import Sidebar from '../../Components/Sidebar/Sidebar';
import CompanyDashboard from '../../Components/CompanyDashboard/CompanyDashboard';
import Tile from '../../Components/Tile/Tile';
import Spinner from '../../Components/Spinners/Spinner';
import CompFinder from '../../Components/CompFinder/CompFinder';
import TenKFinder from '../../Components/TenKFinder/TenKFinder';

interface Props {}

const CompanyPage = (props: Props) => {
  let { ticker } = useParams();

  const [company, setCompany] = useState<CompanyProfile>();

  useEffect(() => {
    const getProfileInit = async () => {
      const result = await getCompanyProfile(ticker!);
      setCompany(result?.data[0]);
    };
    getProfileInit();
  }, []);

  return (
    <>
      {company ? (
        <div className='w-full relative flex ct-docs-disable-sidebar-content overflow-x-hidden'>
          <Sidebar />
          <CompanyDashboard ticker={ticker!}>
            <Tile title='Company Name' subTitle={company.companyName} />
            <Tile title='Price' subTitle={'$' + String(company.price)} />
            <Tile title='DCF' subTitle={'$' + String(company.dcf ?? 5)} />
            <Tile title='Sector' subTitle={company.sector} />
            <CompFinder ticker={company.symbol} />
            <TenKFinder ticker={company.symbol} />
            <p className='bg-white shadow rounded text-medium font-medium text-gray-900 p-3 mt-1 m-4'>
              {company.description}
            </p>
          </CompanyDashboard>
        </div>
      ) : (
        <Spinner />
      )}
    </>
  );
};

export default CompanyPage;
